import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { x, useDown } from '@xstyled/styled-components'
import useHasMounted from '../../lib/useHasMounted'

import Articles from '../components/Articles'
import { fetchArticles, fetchMoreArticles } from '../../store/articles'
import { sectionPageView, setPageType } from '../../store/app'
import { getVisitorId, getSessionId } from '../../store/article'
import WingBanners from '../components/WingBanners'
import Ad from '../components/Ad'
import {FORMATS, MAPPINGS} from '../components/AdFormats'
import ArticleDeck from '../../templates/ArticleDeck'
import { BasicPageSkeleton as Skeleton } from '../components/Skeletons'
import NoImage from '../../../assets/images/general/no-image.png'
import searchGry from '../../../assets/images/icons/search-gry-ico.svg'
import search from '../../../assets/images/icons/search-input-wht-ico.svg'

const DefaultTemplate = ({ articles, section, noImage, isConnected, sectionLabel, moreButton, withReadCount, adPath, sessionId, visitorId }) => (
  <>
    <x.div w='100%' maxWidth={1220} mx='auto' my={50} borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider'>
      <x.h1 text='h1' pb={20}>Search results for: {sectionLabel}</x.h1>
    </x.div>
    <x.div maxWidth={1220} w='100%' mx='auto' mt={50}>
      <ArticleDeck articles={articles} section={section} noImage={noImage} moreButton={moreButton} isConnected={isConnected} withReadCount={withReadCount} adPath={adPath} sessionId={sessionId} visitorId={visitorId} />
    </x.div>
  </>
)

const NotFound = (props) => {
  return (
    <x.div w='100%' maxWidth={1220} mx='auto' my={50} borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider'>
      <x.h1 text='h1' pb={20}>No results for: {props.query.replace('?q=', '')}</x.h1>
      <x.p pb={20}>Try again with different search terms.</x.p>
    </x.div>
  )
}

const SearchPage = (props) => {
  const Template = props.template || DefaultTemplate
  const hasMounted = useHasMounted()
  const downMd = useDown('md')
  setPageType('section')
  useEffect(
    () => {
      if (('/' + props.section) === props.location.pathname) {
        props.sectionPageView(props.location.pathname, props.section, props.visitorId, props.sessionId, props.app.firstRender)
      }
    },
    [props.section]
  )
  return (
    <>
      <x.main px={{ sm: '20px', wAdD: props.app.wallpaperActive ? '0px' : '200px' }} mt={{ sm: '96px', lg: props.app.wallpaperActive ? '0px' : '173px' }} w='100%' maxWidth={{ sm: '1260px', wAdD: props.app.wallpaperActive ? '1220px' : '1660px' }} mx='auto'>
        <WingBanners isConnected={props.isConnected} adPath={props.adPath} location={props.location} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
        {((props.query === '') || (props.query === '?q=')) &&
          <>
            <x.div w='100%' maxWidth={1220} mx='auto' mb={50} mt={{ sm: '50px', lg: '0' }} borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider'>
              <x.h1 text='h1' pb={20}>Search IOL</x.h1>
            </x.div>
            <x.form action='/search' method='get' maXwidth={600} w='100%' m='auto'>
              <x.div flex={{ sm: '100%', lg: '1 1 0' }} display='flex' alignItems='center' justifyContent='center'>
                <x.input type='search' name='q' bg='ltGrey' p={10} text='medium' w={300} appearance='none' borderRadius={0} placeholder='Search IOL' />
                <x.button bg='grey' type='submit' w={38} h={38} display='flex' alignItems='center' justifyContent='center'><x.img src={search} w={24} /></x.button>
              </x.div>
            </x.form>
          </>
        }
        {props.query && (props.query !== '?q=') &&
          <Articles
            {...props} noDiv isConnected={true} loading={Skeleton} section={'search' + props.query} count={24} pageSize={16} withMore moreButtonColour='btn-red' noImage={NoImage} notFound={NotFound} component={Template} />
        }
        {hasMounted && !downMd &&
          <x.div mt={20} mb={50} mx={-20} textAlign='center' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
            <Ad isConnected={props.isConnected} adPath={props.adPath} collapseEmptyDiv slotId='leaderboard-bot' targeting={{ leaderboard: 'bot' }} className='advert' mapping={MAPPINGS['Leaderboard']} {...FORMATS.leaderboard} />
          </x.div>
        }
      </x.main>
    </>
  )
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchArticles, fetchMoreArticles, sectionPageView }, dispatch)

export default withRouter(connect((state) => ({ app: state.app, articles: state.articles, visitorId: getVisitorId(state), sessionId: getSessionId(state) }), mapDispatchToProps)(SearchPage))

SearchPage.propTypes = {
  query: PropTypes.string
}
